<mat-form-field class="example-full-width">
  <mat-label>Checklist Type</mat-label>
  <input
    #input
    type="text"
    placeholder="Select Checklist Type"
    matInput
    [matAutocomplete]="autoDocumentType"
    (input)="filterDocumentTypes($event)"
    [formControl]="ctrlDocumentType"
  />
  <mat-autocomplete
    requireSelection
    #autoDocumentType="matAutocomplete"
    [displayWith]="displayObject"
    (optionSelected)="onDocumentTypeSelected($event)"
  >
    <mat-option
      *ngFor="let documentType of documentTypesFiltered"
      [value]="documentType"
    >
      <div class="d-flex flex-column mb-3">
        <div class="d-flex justify-content-between">
          <div class="bold blue">{{ documentType.description }}</div>
        </div>
      </div>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
